/*eslint no-script-url: 0 */
import React, { Component } from "react";
import { Modal } from 'react-bootstrap';
import { DragDropContainer } from 'react-drag-drop-container';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css'

class RoomModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
          volume: 1.30
        }
    }

    handleOnChange = (value) => {
        this.setState({ volume: value })
    }

	render() {
		const { selectedRoomImage, canvasImage } = this.props;
        let { volume } = this.state
        const pStyle = {transform: 'scale('+volume+')'};
      	return (
			<Modal
				show={this.props.lgShow}
				onHide={this.props.lgClose}
				bsSize="large"
				aria-labelledby="contained-modal-title-lg"
			>
				<Modal.Header closeButton>
					<Modal.Title id="contained-modal-title-lg">
						{selectedRoomImage.getIn(['title', 'rendered'])}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className='slider-horizontal class-zoom'>
						<div className="col-sm-2">
							<div className="row">
								<strong>Zoom In</strong>
							</div>
						</div>
						<div className="col-sm-8">
							<Slider
								min={1}
								max={2}
								step={0.01}
								tooltip={false}
								value={volume}
								orientation="horizontal"
								onChange={this.handleOnChange} />
						</div>
						<div className="col-sm-2 zoom-out-text">
							<div className="row">
								<strong>Zoom Out</strong>
							</div>
						</div>
					</div> 
					<div className="modal-room-image-wrapper">
						<img src={selectedRoomImage.getIn(['_embedded', 'wp:featuredmedia', 0, 'media_details', 'sizes', 'full', 'source_url'])} alt={selectedRoomImage.getIn(['title', 'rendered'])} />
						<div className="modal-room-image-drag">
							<DragDropContainer>
								<img style={pStyle} src={canvasImage} alt="Room" className="room-canvas-image" />
							</DragDropContainer>
						</div>
					</div>
				</Modal.Body>
			</Modal>
      	);
	}
}
export default RoomModal;